
import { InterceptMiddle } from '../../regular';
import Vue from 'vue'
/**
 * 隐藏选项并清除答案
 * @param rowsArr 选项组，
 * @param info 当前试题
 */
export const HideOption = (rowsArr, info) => {
    try {
        rowsArr.forEach((opIndex) => {
            opIndex = Number(opIndex)
            Vue.prototype.$set(info.optionList[opIndex - 1],'show',false)
            switch (info.questionsTypeId) {
                case '10':
                case '14':
                    console.log('info.userAnswerArr :>> ', info.userAnswerArr);
                    info.userAnswerArr = info.userAnswerArr.filter((answer) => {
                        if (answer.indexOf(info.optionList[opIndex - 1].oid) == -1) {
                            return true
                        }
                    })
                    console.log('info.userAnswerArr :>> ', info.userAnswerArr);
                    break;
                case '8':
                case '9':
                    console.log('info.userAnswer :>> ', info.userAnswer);
                    if (info.userAnswer.indexOf(info.optionList[opIndex - 1].oid) != -1) {
                        info.userAnswer = ''
                    }
                    console.log('info.userAnswer :>> ', info.userAnswer);
                    break;
            }
        })
    } catch (error) {
    }
}